import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Titles from "../../common/Titles";
import { Row, Spin } from "antd";
import logo from "../../assets/img/logo2.png";
import SupportApi from "../../apis/SupportApi";
import { showNotification } from "../../common";
import { LoadingOutlined } from "@ant-design/icons";

export default function LookUpSupport() {
  const [urlEncrypt, setUrlEncrypt] = useState();
  const [loading, setLoading] = useState(false);

  const fetchDataDetail = async () => {
    setLoading(true);
    try {
      const res = await SupportApi.encryptPublic();
      if (res && res.status === 200 && res.data.data) {
        setUrlEncrypt(res.data.data);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="LookUpSupport h--100">
      <Spin
        spinning={loading}
        tip="Vui lòng đợi..."
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Helmet>
          <title>{Titles.LOOK_UP_SUPPORT.value}</title>
        </Helmet>
        <Row  className="max-vw-90 wr--70">
          <Row  justify="center" align="middle">
            <img src={logo} className="logo" alt="logo" width={300} height="auto"/>
            <h1 className="title-noti-req">{Titles.LOOK_UP_SUPPORT.value}</h1>
          </Row>
          {urlEncrypt && (
            <Row className="w-full">
              <iframe
                src={urlEncrypt.iframeSearch}
                title="inviteCyberID"
                className="w--100 hr--38"
                loading="lazy"
                width="100%"
                height="100%"
                allow="accelerometer autoplay encrypted-media gyroscope picture-in-picture"
                allowFullScreen
                frameborder="0"
              ></iframe>
            </Row>
          )}
        </Row>
      </Spin>
    </div>
  );
}
